import { percent } from "@justhome/common";
import { Application } from "@justhome/api-core";
import { fetchGetAssumptions } from "@justhome/api-core";
import { FormValues } from "./types";

const mapFormToApplication = async (form: FormValues): Promise<Application> => {
  const assumptions = await fetchGetAssumptions({
    queryParams: { zipCode: form.postalCode },
  });

  const purchasePrice = Number(form.purchasePrice);
  const equity = Number(form.equity);
  const monthlyNetIncome = Number(form.monthlyNetIncome);

  const notaryFee = percent(purchasePrice, assumptions.notaryFeePercentage);
  const realEstateAgentFee = percent(
    purchasePrice,
    assumptions.realEstateAgentFeePercentage,
  );
  const propertyTransferTax = percent(
    purchasePrice,
    assumptions.propertyTransferTaxPercentage,
  );

  const loanAmount =
    notaryFee +
    realEstateAgentFee +
    propertyTransferTax +
    purchasePrice -
    equity;

  return {
    loanAmount,
    preferences: {},
    costs: {
      propertyTransferTax,
      purchasePrice,
      notaryFee,
      realEstateAgentFee,
    },
    property: {
      address: {
        postalCode: form.postalCode,
      },
      type: form.propertyType,
    },
    equity: equity,
    applicationType: "BUY_WITH_SAVINGS",
    monthlyNetIncome,
  };
};

export default mapFormToApplication;
